import store from '@/stores/store'

const Maestro = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/Maestro')
const Index = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Index')

// Consult
const Consult = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Consult')
const ConsultIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/consult/Index')
const ConsultShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/consult/Show')

// Event
const Event = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Event')

// Request
const Request = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Request')
const RequestIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/request/Index')
const RequestShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/request/Show')

// Ticket
const Ticket = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Ticket')
const TicketIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ticket/Index')
const TicketShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ticket/Show')

// TicketDescription
const TicketDescription = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/TicketDescription')

// TicketHistory
const TicketHistory = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/TicketHistory')
const TicketHistoryIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ticket_history/Index')
const TicketHistoryShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ticket_history/Show')

// Chronotachograph
const Chronotachograph = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Chronotachograph')
const ChronotachographIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/chronotachograph/Index')
const ChronotachographShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/chronotachograph/Show')

// ChronotachographHistory
const ChronotachographHistory = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ChronotachographHistory')
const ChronotachographHistoryIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/chronotachograph_history/Index')
const ChronotachographHistoryShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/chronotachograph_history/Show')

// Chronotachograph
const Fee = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Fee')
const FeeIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/fee/Index')
const FeeShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/fee/Show')

// FeeHistory
const FeeHistory = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/FeeHistory')
const FeeHistoryIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/fee_history/Index')
const FeeHistoryShow = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/fee_history/Show')

// ScrapingService
const ScrapingService = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/ScrapingService')

// Vehicle
const Vehicle = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Vehicle')
const VehicleIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/vehicles/Index')

// Driver
const Driver = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/Driver')
const DriverIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/drivers/Index')

// DriverIndications
const DriverIndications = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/DriverIndications')
const DriverIndicationIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/driver_indications/Index')

// DriverIndicationStatuses
const DriverIndicationStatuses = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/DriverIndicationStatuses')
const DriverIndicationStatusIndex = () => import(/* webpackChunkName: "admin_maestro" */ '@/components/admin/maestro/driver_indication_statuses/Index')

// Orders
const Order = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/Orders')
const OrderIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/orders/Index')
const OrderShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/orders/Show')

// Items
const ItemIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/items/Index')

// V3
// ManagerConsults
const ManagerConsults = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/v3/ManagerConsults')
const ManagerConsultsIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/v3/manager-consults/Index')
const ManagerConsultsShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/maestro/v3/manager-consults/Show')

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {name: 'Maestro'},
        ]
      },
      path: '/',
    },
    {
      children: [
        {
          component: ConsultIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Consultas'},
            ]
          },
          path: '/',
        },
        {
          component: ConsultShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/consults', name: 'Consultas'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: Consult,
      path: 'consults',
    },
    {
      component: Event,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/maestro', name: 'Maestro'},
          {name: 'Eventos'},
        ]
      },
      path: 'events'
    },
    {
      children: [
        {
          component: RequestIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Requisições'},
            ]
          },
          path: '/',
        },
        {
          component: RequestShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/requests', name: 'Requisições'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: Request,
      path: 'requests',
    },
    {
      children: [
        {
          component: TicketIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Multas'},
            ]
          },
          path: '/',
        },
        {
          component: TicketShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/tickets', name: 'Multas'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: Ticket,
      path: 'tickets',
    },
    {
      component: TicketDescription,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/maestro', name: 'Maestro'},
          {name: 'Descrições das Multas'}
        ]
      },
      path: 'ticket_descriptions'
    },
    {
      children: [
        {
          component: TicketHistoryIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Histórico Multas'},
            ]
          },
          path: '/',
        },
        {
          component: TicketHistoryShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/ticket_histories', name: 'Histórico Multas'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: TicketHistory,
      path: 'ticket_histories',
    },
    {
      component: ScrapingService,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/maestro', name: 'Maestro'},
          {name: 'Scraping Services'}
        ]
      },
      path: 'scraping_services'
    },
    {
      children: [
        {
          component: DriverIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Motoristas'},
            ]
          },
          path: '/',
        }
      ],
      component: Driver,
      path: 'drivers',
    },
    {
      children: [
        {
          component: VehicleIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Veículos'},
            ]
          },
          path: '/',
        }
      ],
      component: Vehicle,
      path: 'vehicles',
    },
    {
      children: [
        {
          component: ChronotachographIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Crono'},
            ]
          },
          path: '/',
        },
        {
          component: ChronotachographShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/chronotachographs', name: 'Crono'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: Chronotachograph,
      path: 'chronotachographs',
    },
    {
      children: [
        {
          component: ChronotachographHistoryIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Histórico Crono'},
            ]
          },
          path: '/',
        },
        {
          component: ChronotachographHistoryShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/chronotachograph_histories', name: 'Histórico Crono'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: ChronotachographHistory,
      path: 'chronotachograph_histories',
    },
    {
      children: [
        {
          component: FeeIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Taxa'},
            ]
          },
          path: '/',
        },
        {
          component: FeeShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/fees', name: 'Taxa'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: Fee,
      path: 'fees',
    },
    {
      children: [
        {
          component: FeeHistoryIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Histórico Taxa'},
            ]
          },
          path: '/',
        },
        {
          component: FeeHistoryShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/fee_histories', name: 'Histórico Taxa'},
              {dynamicName: () => store.getters.getNameBreadcrumb},
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: FeeHistory,
      path: 'fee_histories',
    },
    {
      children: [
        {
          component: OrderIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Orders'},
            ]
          },
          path: '/'
        },
        {
          component: OrderShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/orders', name: 'Orders'},
              {dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show'},
            ]
          },
          path: ':id',
          props: true
        },
      ],
      component: Order,
      path: 'orders',
    },
    {
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/maestro', name: 'Maestro'},
          {name: 'Items'},
        ]
      },
      component: ItemIndex,
      path: 'items',
    },
    {
      children: [
        {
          component: ManagerConsultsIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Admin'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Manager Consults'},
            ]
          },
          path: '/',
        },
        {
          component: ManagerConsultsShow,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Admin'},
              {link: '/admin/maestro', name: 'Maestro'},
              {link: '/admin/maestro/manager-consults', name: 'Manager Consults'},
              {dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show'},
            ]
          },
          path: ':id',
          props: true
        },
       ],
      component: ManagerConsults,
      path: 'manager-consults'
    },
    {
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/maestro', name: 'Maestro'},
          {name: 'Scraping Services'}
        ]
      },
      component: ScrapingService,
      path: 'scraping_services'
    },
    {
      children: [
        {
          component: DriverIndicationIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Indicação de Condutores'}
            ]
          },
          path: '/'
        }
      ],
      component: DriverIndications,
      path: 'driver-indications'
    },
    {
      children: [
        {
          component: DriverIndicationStatusIndex,
          meta: {
            breadcrumbs: [
              {link: '/admin', name: 'Administração'},
              {link: '/admin/maestro', name: 'Maestro'},
              {name: 'Status de Indicação de Condutores'}
            ]
          },
          path: '/'
        }
      ],
      component: DriverIndicationStatuses,
      path: 'driver_indication_statuses'
    },
  ],
  component: Maestro,
  path: 'maestro'
}
